import { render, staticRenderFns } from "./HighEndInfoTab.vue?vue&type=template&id=6ae73352&scoped=true&"
import script from "./HighEndInfoTab.vue?vue&type=script&lang=js&"
export * from "./HighEndInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./HighEndInfoTab.vue?vue&type=style&index=0&id=6ae73352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae73352",
  null
  
)

export default component.exports